// extracted by mini-css-extract-plugin
module.exports = {"card":"dh-dh-klima-spesial-english-card--f554ca6ae78be9eeb2a22e3799d0ad7b","cardActive":"dh-dh-klima-spesial-english-cardActive--c56bae1c79edfb153cd5032ed3e40ebd"};